'use strict';

require('script-loader!./plugins/jquery.meanmenu');

(function($) {

    const header = document.getElementById('rs-scroll-nav');
    const body = document.getElementsByTagName('body')[0];

    const spaceName = {};

    spaceName.init = function() {
        this.stickySidebar();
        this.lazyYoutube();
    };

    /**
     * 判断是否为移动端
     */
    spaceName.isMobile = function(opts) {
        const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
        const notMobileRE = /CrOS/;

        const tabletRE = /android|ipad|playbook|silk/i;

        if (!opts) opts = {};
        let ua = opts.ua;
        if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
        if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
            ua = ua.headers['user-agent'];
        }
        if (typeof ua !== 'string') return false;

        let result =
                (mobileRE.test(ua) && !notMobileRE.test(ua)) ||
                (!!opts.tablet && tabletRE.test(ua));

        if (
            !result &&
            opts.tablet &&
            opts.featureDetect &&
            navigator &&
            navigator.maxTouchPoints > 1 &&
            ua.indexOf('Macintosh') !== -1 &&
            ua.indexOf('Safari') !== -1
        ) {
            result = true;
        }

        return result;
    };

    /**
     * Header sticky
     */
    spaceName.navSticky = function() {
        const sticky = header.offsetTop + 100;

        if (window.scrollY > sticky) {
            header.classList.add('is-sticky');
            body.classList.add('is-sticky');
        } else {
            header.classList.remove('is-sticky');
            body.classList.remove('is-sticky');
        }
    };

    /**
     * Sticky Sidebar
     *
     * div.js-sticky-left>div.theiaStickySidebar | div.js-sticky-right>div
     */
    spaceName.stickySidebar = function() {
        if ($(document).width() > 1024 && $.isFunction($.fn.theiaStickySidebar)) {
            $('.js-sticky-left, .js-sticky-right').theiaStickySidebar({
                additionalMarginTop: 32,
            });
        }
    };

    /**
     * Lazy Load Youtube Video
     */
    spaceName.lazyYoutube = function() {

        if ($.isFunction($.fn.lazyYT)) {
            $('.js-lazyYT').lazyYT({
                youtube_parameters: 'rel=0',
                loading_text      : 'Loading...',
                display_title     : false,
                default_ratio     : '16:9',
                display_duration  : false,
                video_loaded_class: 'lazyYT-video-loaded',
                container_class   : 'lazyYT-container',
            });
        }

        // 给 iframe 添加 wrap, 以实现自适应
        $('.type-docs iframe').wrap('<div class=\'rs-iframe-wrap\' />');

    };

    /**
     * Play video in manigicPopup
     */
    spaceName.wow = function() {
        if ($.isClass('WOW')) {
            new WOW().init();
        }
    };

    $(document).ready(function() {
        spaceName.init();
    });

    window.onscroll = function() {
        //spaceName.navSticky();
    };

})(jQuery);
